<div fxLayout="row" fxLayoutAlign="space-between center" [fxLayoutGap]="gap || '0px'">
    <mat-divider fxFlex="noshrink"></mat-divider>
    <div class="content">
        <ng-content></ng-content>
    </div>
    <mat-divider fxFlex="noshrink"></mat-divider>
</div>
